
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"13","viewBox":"0 0 13 13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0.858817 7.17188H5.45424V11.7673C5.45424 12.2344 5.83845 12.6261 6.31306 12.6261C6.78767 12.6261 7.17187 12.2344 7.17187 11.7673V7.17188H11.7673C12.2344 7.17188 12.6261 6.78767 12.6261 6.31306C12.6261 5.83845 12.2344 5.45424 11.7673 5.45424H7.17187V0.858817C7.17187 0.391741 6.78767 0 6.31306 0C5.83845 0 5.45424 0.391741 5.45424 0.858817V5.45424H0.858817C0.391741 5.45424 0 5.83845 0 6.31306C0 6.78767 0.391741 7.17188 0.858817 7.17188Z","fill":"#A5D8FF"}})])
          )
        }
      }
    